import { createResource, deleteResource, listResources } from "./resource";

export const listCommentsByResourceId = async (resourceId: string) => {
  return listResources({
    fields: `
    items {
      id
      sk
      name
      content {
        body
      }
      creator {
        id
        sk
        firstName
        lastName
        avatarHash
      }
      createdAt
      updatedAt
    }
    nextToken
    `,
    variables: {
      id: resourceId,
      sk: {
        beginsWith: `comment#`,
      },
    },
  });
};

export const createComment = (params: {
  workspaceId: string;
  bankId?: string;
  creatorId: string;
  id: string;
  sk: string;
  text: string;
}) => {
  return createResource({
    variables: {
      id: params.id,
      sk: "comment#" + new Date().toISOString(),
      creatorId: params.creatorId,
      content: {
        body: params.text,
      },
      workspaceId: params.workspaceId,
      resourceId: [params.id, params.sk].join("/"),
      schemaVersion: "2020-01-01",
    },
  });
};

export const deleteComment = (params: {
  id: string;
  sk: string;
  workspaceId: string;
}) => {
  return deleteResource({
    id: params.id,
    sk: params.sk,
    workspaceId: params.workspaceId,
  });
};
